// if you need to add custom js put it in here
$(window).load(function () {
    $('.HButton').bootstrapSwitch();
    $('.about-content-wrapper').matchHeight();
    $('.blogTitle').matchHeight();
    $('.blogDescription').matchHeight();
    $('.pf-recent-related-product-item.product-match-height').matchHeight();
    $('.testimonial-msg').matchHeight();
    InitBannerSlider();
});
$(function () {
    $(window).on('resize', SetNavDropdownMaxHeight);
    $(document).on('click', '.menu-button', SetNavDropdownMaxHeight);
    $(document).on('click', '.nav-link.nav-dropdown', SetNavDropdownMaxHeight);
    $(document).on('click', '.bag-opener.w-nav-link', SetNavDropdownMaxHeight);
    $('#bag-opener').click(function () {
        SetNavDropdownMaxHeight();
    });   
    $('.nav-menu.w-nav-menu .w-dropdown').hover(function (e) {
        e.preventDefault();
        if ($(window).width() < 768)
            return;

        var openClass = 'w--open';
        if (e.type === 'mouseenter') {
            $(this).find('.w-dropdown-toggle').addClass(openClass);
            $(this).find('.w-dropdown-list').addClass(openClass);
            $(this).find('.w-dropdown-toggle').find('.fa-angle-down').addClass('fa-angle-up');
            $(this).find('.w-dropdown-toggle').find('.fa-angle-up').removeClass('fa-angle-down');
        } else if (e.type === 'mouseleave') {
            $(this).find('.w-dropdown-toggle').removeClass(openClass);
            $(this).find('.w-dropdown-list').removeClass(openClass);
            $(this).find('.w-dropdown-toggle').find('.fa-angle-up').addClass('fa-angle-down');
            $(this).find('.w-dropdown-toggle').find('.fa-angle-down').removeClass('fa-angle-up');
        }
    });
    $(window).on('resize', InitBannerSlider);
});

function SetNavDropdownMaxHeight() {
    if ($(window).width() < 768) {
        $('.w-nav-overlay').css('max-height', ($(window).height() - $('header.header').outerHeight()) + 'px');
        $('.topheader').css('max-height', ($(window).height() - $('header.header').outerHeight()) + 'px');
        $('.mega-list').css('max-height', '100%');
    } else {
        $('.mega-list').css('max-height', ($(window).height() - $('header.header').outerHeight()) + 'px');
        $('.topheader').css('max-height', '400px');
        $('.topheader').css('overflow', 'auto');
        $('.w-nav-overlay').css('max-height', '100%');
    }
}
function InitBannerSlider() {
    var $visibleBanner = $('.w-slider:visible');
    if (!$visibleBanner.data('initialised')) {
        Webflow.require('slider').redraw();
        $visibleBanner.data('initialised', true);
    }
}